// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerLabel":"Footer_footerLabel__PCjNt","footerLogo":"Footer_footerLogo__fb42F","footerText":"Footer_footerText__rlW5Y"};